export function removeSVGDimensions(svgString: string): string {
  return svgString.replace(/\s?(width|height)=".*?"/g, '');
}
